// eslint-disable-next-line
import React from 'react';
import { Icon } from '@cb/apricot-react';
// Utility functions for sorting and generating icons in roster components.
// TODO: Update the Roster and RosterII components to use headerSortOrder and generateIcon from this file
export interface SortField {
  name: string;
  order: string;
}

export interface Header {
  title: string;
  sortField: string[];
  className?: string;
}

export function headerSortOrder(sortFields: SortField[], field = ''): 'none' | 'ascending' | 'descending' {
  const matchingField = sortFields.find((item) => item.name === field);
  if (!matchingField || !matchingField.order) {
    return 'none';
  }
  return matchingField.order === 'asc' ? 'ascending' : 'descending';
}

export function generateIcon(field: string[], sortFields: SortField[]): JSX.Element | null {
  if (!field || field.length === 0) {
    return null;
  }
  const sortOrder = headerSortOrder(sortFields, field[field.length - 1]);
  if (sortOrder === 'none') {
    return null;
  }
  return <Icon name={sortOrder === 'ascending' ? 'sort-asc' : 'sort-desc'} decorative />;
}
